module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[97]218.a9e0934.woff2";